import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function dispose() {
}
function close() {
  return this.jz();
}
var HttpEngineClass;
function HttpEngine() {
  if (HttpEngineClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'HttpEngine', VOID, VOID, VOID, [1]);
    HttpEngineClass = $;
  }
  return HttpEngineClass;
}
//region block: exports
export {
  dispose as disposehycj9shx8d5q,
  HttpEngine as HttpEngine345320iy1heif,
};
//endregion

//# sourceMappingURL=HttpEngine.mjs.map
